// extracted by css-extract-rspack-plugin
export default {"showMore":"home-fragment__Headline_showMore__2RzYh","chevronLeft":"home-fragment__Headline_chevronLeft__G8LLS","headline":"home-fragment__Headline_headline__h2fRP"};